import base64 from 'base-64';

export const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new window.FileReader();
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new window.DOMException('Please pass a valid file.'));
    };
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.readAsText(file);
  });
};

export const readImageFile = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onerror = (error) => {
      console.error('Error reading file -', error);
      reject(error);
    };
    fileReader.onload = () => {
      resolve(fileReader.result.toString());
    };
    fileReader.readAsDataURL(file);
  });
};

export const readImageFiles = (files) => {
  return Promise.all(files.map(readImageFile));
};

export const encodeFile = async (file) => {
  const result = await readFile(file);
  return base64.encode(result);
};
